import { ECG_CHART_UNIT } from 'constant/ChartEditConst';
import { BEAT_TYPE } from 'constant/EventConst';
/**
 *
 * @param {Object}_selectHistogram
 * @param {number} _previousSelectedBpm
 * @param {Array} _selectBeatLabelButtonDataList
 * @param {Array[number]} selectedBeatBtnWaveformIndexList
 * @param {number} _selectCurrPosition
 * @param {0|1|2|3|undefined} updateBeatType
 * @returns
 */
export const handleNextSelectBpm = ({
  _selectHistogram,
  _previousSelectedBpm,
  _selectBeatLabelButtonDataList,
  selectedBeatBtnWaveformIndexList,
  _selectCurrPosition,
  updateBeatType,
}) => {
  /**
   *  xAxisPoint: tenSecStrip에서 onsetWI를 기준으로 WI를 0부터 ~ 2500 사이의 값으로 formatting 한 변수 (ex, 차트의 처음 === 0, 가운데 xAxisPoint === 1250, 마지막 === 2500)
   */
  const halfTenSecWaveformIdx = ECG_CHART_UNIT.HALF_TEN_SEC_WAVEFORM_IDX;
  const indexOfCenterWaveformIndex = _selectBeatLabelButtonDataList.findIndex(
    (data) => data.xAxisPoint === halfTenSecWaveformIdx
  );
  // 가운데 비트의 인덱스 - 1 의 xAxisPoint
  const xAxisPointOfPreviousIndexOfCenterIndex =
    _selectBeatLabelButtonDataList[indexOfCenterWaveformIndex - 1]
      ?.xAxisPoint || 0;
  const isSelectedWaveformIndexBetweenPreviousPointAndCenterPoint =
    selectedBeatBtnWaveformIndexList.some(
      (selectedBeatWaveformIndex) =>
        xAxisPointOfPreviousIndexOfCenterIndex <= selectedBeatWaveformIndex &&
        selectedBeatWaveformIndex <= halfTenSecWaveformIdx
    );

  let nextSelectBpm = _previousSelectedBpm;
  let nextPosition = _selectCurrPosition;

  // 마지막 포지션에서 bpm에 변경이 생긴 경우
  // - bpm 변경되는 케이스
  //     : 선택된 이벤트와 선택된 비트의 바로 직전 비트 사이에 비트가 추가 될 때
  //     : 선택된 이벤트 또는 이전 비트가 삭제 될 때
  if (
    _selectCurrPosition !== 1 &&
    _selectHistogram[_previousSelectedBpm] === _selectCurrPosition &&
    isSelectedWaveformIndexBetweenPreviousPointAndCenterPoint &&
    (updateBeatType === undefined || updateBeatType === BEAT_TYPE.NOISE)
  ) {
    nextPosition = _selectCurrPosition - 1;
    return { nextSelectBpm, nextPosition };
  }

  // 포지션이 1 of 1 이고, patch에 의해 가운데 bpm에 변경이 생긴 경우
  if (
    _selectHistogram[_previousSelectedBpm] === 1 &&
    isSelectedWaveformIndexBetweenPreviousPointAndCenterPoint &&
    updateBeatType != null &&
    updateBeatType !== 3
  ) {
    return { nextSelectBpm, nextPosition };
  }

  // 포지션이 1 of 1 이고, 가운데 bpm에 변경이 생길 경우
  if (
    _selectHistogram[_previousSelectedBpm] === 1 &&
    isSelectedWaveformIndexBetweenPreviousPointAndCenterPoint
  ) {
    const histogramArray = Object.keys(_selectHistogram).filter(
      (bpm) => _selectHistogram[bpm]
    );
    const currentBpmIndex = histogramArray.findIndex(
      (bpm) => Number(bpm) === _previousSelectedBpm
    );

    nextSelectBpm =
      currentBpmIndex === histogramArray.length - 1
        ? Number(histogramArray[currentBpmIndex - 1])
        : Number(histogramArray[currentBpmIndex + 1]);
    return { nextSelectBpm, nextPosition };
  }

  return { nextSelectBpm, nextPosition };
};
